<!-- 大屏收益 -->
<template>
  <div
    v-loading="dataLoadingStatus === 'loading'"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="screen"
  >
    <ScreenHorizontal
      v-if="dataLoadingStatus !== 'fail' && screenComponentType === 'horizontal'"
      ref="screenHorizontalRef"
      v-loading="dataLoadingStatus === 'loading'"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :tvdata="tvScreenData"
    />
    <ScreenVertical
      v-if="dataLoadingStatus !== 'fail' && screenComponentType === 'vertical'"
      ref="screenVerticalRef"
      v-loading="dataLoadingStatus === 'loading'"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :tvdata="tvScreenData"
    />
    <DataLoadFail v-if="dataLoadingStatus === 'fail'" />
  </div>
</template>

<script>
import { GetFeiNiYaLargeScreen } from '@apis/CustomizeLargeScreen.js'

import ScreenVertical from './ScreenVertical.vue'
import ScreenHorizontal from './ScreenHorizontal.vue'
import DataLoadFail from './component/dataLoadFail.vue'

export default {
  components: {
    ScreenVertical,
    ScreenHorizontal,
    DataLoadFail
  },
  data () {
    return {
      dataLoadingStatus: 'loading',
      tvScreenData: {},
      screenComponentType: '',

      /** 数据刷新间隔 */
      dataRefreshInterval: 1000 * 60 * 5,
      /** 数据刷新定时器 */
      dataRefreshTimer: null
    }
  },
  created () {
    this.$i18n.locale = 'en'
    localStorage.setItem('language', 'en')
    this.$store.commit('app/CHANGE_LANG')
  },
  mounted () {
    this.getFeiNiYaLargeScreen().then(() => {
      this.setScreenComponentType()
    })
  },
  beforeDestroy () {
    this.clearDataRefreshTimer()
  },
  methods: {

    /**
     * 设置大屏组件
     * @param {*} component 组件
     */
    setScreenComponentType () {
      if (this.dataLoadingStatus !== 'loaded') return
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight
      if (windowWidth > windowHeight) {
        this.screenComponentType = 'horizontal'
      } else {
        this.screenComponentType = 'vertical'
      }
    },

    /**
     * 获取费尼亚电站大屏数据
     */
    getFeiNiYaLargeScreen () {
      return new Promise((resolve, reject) => {
        this.dataLoadingStatus = 'loading'
        GetFeiNiYaLargeScreen().then(res => {
          this.tvScreenData = res.data
          this.dataLoadingStatus = 'loaded'
          resolve(res.data)
        }).catch(() => {
          this.dataLoadingStatus = 'fail'
          reject()
        }).finally(() => {
          this.setDataRefreshTimer()
        })
      })
    },

    /**
     * 设置数据刷新定时器
     */
    setDataRefreshTimer () {
      if (this.dataRefreshTimer) {
        window.clearTimeout(this.dataRefreshTimer)
        this.dataRefreshTimer = null
      }
      this.dataRefreshTimer = window.setTimeout(() => {
        this.getFeiNiYaLargeScreen().then(() => {
          this.refreshData()
        })
      }, this.dataRefreshInterval)
    },

    /**
     * 刷新数据
     */
    refreshData () {
      if (this.dataLoadingStatus !== 'loaded') return
      if (this.screenComponentType === 'horizontal') {
        this.$refs.screenHorizontalRef.refreshData()
      } else if (this.screenComponentType === 'vertical') {
        this.$refs.screenVerticalRef.refreshData()
      }
    },

    /**
     * 清除数据刷新定时器
     */
    clearDataRefreshTimer () {
      if (this.dataRefreshTimer) {
        window.clearTimeout(this.dataRefreshTimer)
        this.dataRefreshTimer = null
      }
    }
  }
}
</script>
<style scoped>
.screen {
  width:100vw;
  height:100vh;
  overflow: auto;
}
</style>
